import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/layout/Layout'
import personnelRoutes from './personnel'
import approveRoutes from './approve'
import businessCenterRoutes from './business-center'
import financeRoutes from './finance'
import operatingDataRoutes from './operating-data'
import salesBusinessRoutes from './sales-business'
import operationsToolsRoutes from './operations-tools'

export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '/external/approval',
    name: 'externalApproval',
    component: () => import('@/views/approve/externalApproval/index'),
    hidden: true
  },
  {
    path: '/welcome',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'welcome',
        component: () => import('@/views/welcome/index'),
        meta: {title: '\u6b22\u8fce\u9875'}
      }
    ]
  },
  {
    path: '/messageDetail',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'messageDetail',
        component: () => import('@/views/home/message/index'),
        meta: { title: '通知详情' }
      }
    ]
  },
  /*  {
    path: '',
    component: Layout,
    redirect: '/home',
    name:'shouye',
    meta: {title: '首页', icon: 'home'},
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index-home'),
        meta: {title: '驾驶舱', icon: 'dashboard'}
      },
      {
        path: 'messageDetail',
        name: 'messageDetail',
        component: () => import('@/views/home/message/index'),
        meta: {title: '通知详情', icon: 'dashboard'},
        hidden: true
      },
      {
        path: 'Setting',
        name: 'Setting',
        component: () => import('@/views/home/setting/index'),
        meta: {title: '设置', icon: 'dashboard'},
        hidden: true
      }
    ]
  },  */
]

export const asyncRouterMap = [
 // 👉 首页动态路由（唯一实例，无重复）
  {
    path: '', // 根路径，登录后默认匹配
    component: Layout,
    redirect: '/home', // 重定向到首页核心页面
    name: 'shouye', // 首页权限标识（必须和用户 menus 中的标识一致，比如 'shouye'）
    meta: { title: '驾驶舱', icon: 'home' },
    children: [
      // 首页核心页面（驾驶舱）
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index-home'),
        meta: { title: '首页', icon: 'dashboard' }
      },
      {
        path: 'materialAnalysis',
        name: 'materialAnalysis',
        component: () => import('@/views/home/materialAnalysis/index'),
        meta: { title: '素材分析', icon: 'chart_bar_fill' }
      },
      // 设置页：补全 component，保留 hidden: true
      {
        path: 'Setting',
        name: 'Setting',
        component: () => import('@/views/home/setting/index'), // 必须补全组件路径
        meta: { title: '设置' },
        hidden: true
      }
    ]
  },
  
  personnelRoutes,
  approveRoutes,
  operationsToolsRoutes,
  financeRoutes,
  operatingDataRoutes,

  businessCenterRoutes,
 
  salesBusinessRoutes,
]

function createRouter(dynamicRoutes = []) {
  return new Router({
    //mode: 'history', //后端支持可开
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap.concat(dynamicRoutes)
  })
}

const router = createRouter()

// 一次性替换匹配器，避免逐个 addRoute 触发正在进行的登录跳转。
export function replaceUserRoutes(routes = []) {
  router.matcher = createRouter(routes).matcher
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js